import { createContext, useContext, useState } from "react";

import axios from "axios";

const WatchlistContext = createContext();

export const WatchlistProvider = ({ children }) => {
  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /* ================= GET WATCHLIST ================= */
  // const fetchWatchlist = async (userID) => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const res = await axios.get(`${BASE_URL}/api/watchlist`, {
  //       params: { userID },
  //     });

  //     setWatchlist(res.data || []);
  //     return res.data;
  //   } catch (err) {
  //     console.error("Fetch watchlist error:", err);
  //     setError(err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchWatchlist = async (userID) => {
    if (!userID) {
      setWatchlist([]);
      return [];
    }

    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${BASE_URL}/api/watchlist`, {
        params: { userID },
      });

      const rows = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
          ? res.data
          : [];

      setWatchlist(rows);

      return rows;
    } catch (err) {
      console.error("Fetch watchlist error:", err);

      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to fetch watchlist",
      );

      setWatchlist([]);

      return [];
    } finally {
      setLoading(false);
    }
  };
  /* ================= ADD TO WATCHLIST ================= */
  // const addToWatchlist = async ({ userID, symbol, securityId }) => {
  //   try {
  //     await axios.post(`${BASE_URL}/api/addWatchlist`, {
  //       userID,
  //       symbol,
  //       securityId,
  //     });

  //     // 🔥 Optimistic update (no refetch needed)
  //     setWatchlist((prev) => [...prev, { userID, symbol, securityId }]);
  //   } catch (err) {
  //     console.error("Add error:", err);
  //     setError(err.message);
  //     throw err;
  //   }
  // };
  // const addToWatchlist = async ({ userID, symbol, securityId }) => {
  //   try {
  //     setError(null);

  //     const res = await axios.post(`${BASE_URL}/api/addWatchlist`, {
  //       userID,
  //       symbol,
  //       securityId,
  //     });

  //     return res?.data;
  //   } catch (err) {
  //     console.error("Add error:", err);

  //     setError(
  //       err?.response?.data?.message || err?.message || "Failed to add stock",
  //     );

  //     throw err;
  //   }
  // };
  const addToWatchlist = async ({ userID, symbol, securityId }) => {
    try {
      setError(null);

      const res = await axios.post(`${BASE_URL}/api/addWatchlist`, {
        userID,
        symbol,
        securityId,
      });

      // ✅ Add to local state so the UI updates immediately
      // setWatchlist((prev) => [...prev, { userID, symbol, securityId }]);

      return res?.data;
    } catch (err) {
      console.error("Add error:", err);
      setError(
        err?.response?.data?.message || err?.message || "Failed to add stock",
      );
      throw err;
    }
  };
  /* ================= REMOVE FROM WATCHLIST ================= */
  // const removeFromWatchlist = async ({ userID, symbol }) => {
  //   try {
  //     await axios.delete(`${BASE_URL}/api/removeWatchlist`, {
  //       data: { userID, symbol },
  //     });

  //     // 🔥 Optimistic update
  //     setWatchlist((prev) => prev.filter((item) => item.symbol !== symbol));
  //   } catch (err) {
  //     console.error("Remove error:", err);
  //     setError(err.message);
  //     throw err;
  //   }
  // };
  const removeFromWatchlist = async ({ userID, symbol }) => {
    try {
      setError(null);

      await axios.delete(`${BASE_URL}/api/removeWatchlist`, {
        data: { userID, symbol },
      });

      const normalizedSymbol = symbol?.trim()?.toUpperCase();

      setWatchlist((prev) =>
        prev.filter(
          (item) => item?.symbol?.trim()?.toUpperCase() !== normalizedSymbol,
        ),
      );
    } catch (err) {
      console.error("Remove error:", err);

      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to remove stock",
      );

      throw err;
    }
  };
  /* ================= HELPER ================= */
  // const isInWatchlist = (symbol) => {
  //   return watchlist.some((item) => item.symbol === symbol);
  // };
  const isInWatchlist = (symbol) => {
    const normalizedSymbol = symbol?.trim()?.toUpperCase();

    return watchlist.some(
      (item) => item?.symbol?.trim()?.toUpperCase() === normalizedSymbol,
    );
  };
  const resetWatchlist = () => {
    setWatchlist([]);
  };

  const toggleNotification = async ({ userID, symbol, isNotified }) => {
    try {
      await axios.put(`${BASE_URL}/api/toggleNotifications`, {
        userID,
        symbol,
        isNotified,
      });

      // ✅ Update local state (important)
      setWatchlist((prev) =>
        prev.map((item) =>
          item.symbol === symbol ? { ...item, isNotified } : item,
        ),
      );
    } catch (err) {
      console.error("Toggle notification error:", err);
    }
  };
  const updatePotentialUpside = async ({ userID, symbol, potentialUpside }) => {
    try {
      await axios.put(`${BASE_URL}/api/updateUpside`, {
        userID,
        symbol,
        potentialUpside,
      });

      // ✅ update local state
      setWatchlist((prev) =>
        prev.map((item) =>
          item.symbol === symbol ? { ...item, potentialUpside } : item,
        ),
      );
    } catch (err) {
      console.error("Update upside error:", err);
    }
  };
  const updatePrices = async ({ userID, symbol, entryPrice, exitPrice }) => {
    try {
      await axios.put(`${BASE_URL}/api/updatePrices`, {
        userID,
        symbol,
        entryPrice,
        exitPrice,
      });

      // 🔥 Optimistic update
      setWatchlist((prev) =>
        prev.map((item) =>
          item.symbol === symbol ? { ...item, entryPrice, exitPrice } : item,
        ),
      );
    } catch (err) {
      console.error("Update prices error:", err);
    }
  };

  return (
    <WatchlistContext.Provider
      value={{
        watchlist,
        loading,
        error,
        fetchWatchlist,
        addToWatchlist,
        removeFromWatchlist,
        isInWatchlist,
        resetWatchlist,
        toggleNotification,
        updatePotentialUpside,
        updatePrices,
      }}
    >
      {children}
    </WatchlistContext.Provider>
  );
};

/* ================= HOOK ================= */
export const useWatchlist = () => useContext(WatchlistContext);
